export const INPUT_FIELD_TYPE = {
  INPUT: "input",
  TEXTAREA: "textarea",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  SWITCH: "switch",
  SELECT: "select",
  SEARCHABLE_SELECT: "searchable_select",
  DRAG_DROP: "drag_drop",
}

export const INPUT_TYPE = {
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  DATE: "date",
  DATETIME_LOCAL: "datetime-local",
  EMAIL: "email",
  TEL: "tel"
}

export const FIELD_SIZE = {
  SMALL: "sm",
  MEDIUM: "md",
  LARGE: "lg",
}